import { grey } from '@material-ui/core/colors';

export const DUCKS_NAMESPACE = 'cw-demowallet-transfer-demo-ui';
export const LOCALSTORAGE_KEY = 'cw-demowallet-transfer-demo-ui';
export const ItemTypes = {
  WALLET_CARD: 'walletCard',
};
export const WalletColumnConstants = {
  walletCardHeight: 72,
  transactionColumnWidth: 250,
  transactionColumnMargin: 15,
  transactionRowHeight: 50,
  arrowColor: grey[800],
  arrowSize: 10,
  clearingColor: '#3f51b5',
};
